import { Component, OnDestroy, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';
import { SvgIconHostDirective } from 'projects/shared/svg-icons/svg-icon-host.directive';

@Component({
    selector: 'wizard-button-group',
    templateUrl: 'wizard-button-group.component.html',
    standalone: false
})
export class WizardButtonGroupComponent implements OnInit, OnDestroy {

  @ViewChild(SvgIconHostDirective, { static: true }) svgIconHost!: SvgIconHostDirective;

  @Input() backEnabled: boolean = true;
  @Input() nextEnabled: boolean = true;
  @Input() backVisible: boolean = true;
  @Input() nextVisible: boolean = true;
  @Input() customButtons: CustomButton[] = [];

  @Input()
  set nextButtonText(nextButtonText: string | undefined | null) {
    if (!nextButtonText) {
      return;
    }
    this._nextButtonText = nextButtonText;
    this._oldNextButtonText = nextButtonText;
    this._nextButtonTextExplicitlySet = true;
  }

  get nextButtonText(): string {
    return this._nextButtonText;
  }

  spinnerVisible: boolean = false;

  private _nextButtonText: string = '';
  private _oldNextButtonText: string = '';
  private _nextButtonTextExplicitlySet: boolean = false;
  private _langChangeSub?: Subscription;

  public startSpinner = (): void => {
    this.spinnerVisible = true;
    this._oldNextButtonText = this.nextButtonText;
    this._nextButtonText = this._translocoService.translate('common.pleaseWait');
  }

  public stopSpinner = (): void => {
    this.spinnerVisible = false;
    this._nextButtonText = this._oldNextButtonText;
  }

  @Output() nextClicked = new EventEmitter<any>();
  @Output() backClicked = new EventEmitter<any>();

  onBackClicked = () => {
    this.backClicked.emit();
  }

  onNextClicked = () => {
    this.nextClicked.emit();
  }

  constructor(private readonly _translocoService: TranslocoService) {
    this._nextButtonText = this._translocoService.translate('common.continue');
    this._oldNextButtonText = this._nextButtonText;
  }

  ngOnInit() {
    this._langChangeSub = this._translocoService.langChanges$.subscribe(() => {
      if (this.spinnerVisible) {
        this._nextButtonText = this._translocoService.translate('common.pleaseWait');
      }
      if (this._nextButtonTextExplicitlySet) {
        return;
      }
      const translated = this._translocoService.translate('common.continue');
      this._oldNextButtonText = translated;
      if (!this.spinnerVisible) {
        this._nextButtonText = translated;
      }
    });
  }

  ngOnDestroy() {
    this._langChangeSub?.unsubscribe();
  }
}

export class CustomButton {
  label: string;
  onClick: () => void;
}
